// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18lms","colBig":"styles_colBig__257n-","colSmall":"styles_colSmall__O0RJ_"};